import { useTranslation } from "react-i18next"
import { UserAvatarTooltip } from "@/components/avatar-user-tooltip"
import { UserProvider } from "@/components/user-wrapper"
import { formatDate } from "@/lib/format-date"

type LastModificationInfo = {
  updatedAt: string
  updatedBy: string
  "data-testid"?: string
  displayedText?: string
}

const LastModificationInfo = ({ updatedAt, updatedBy, "data-testid": testId, displayedText }: LastModificationInfo) => {
  const { t } = useTranslation()
  return (
    <div className="text-on-surface-subdued mr-auto flex shrink-0 items-center gap-2 text-xs tracking-[0.25px]">
      <UserProvider
        userName={updatedBy}
        render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={updatedBy} />}
      />
      <div>
        {displayedText ? t(displayedText) : t("patient.therapyPrescription.updatedOn")}{" "}
        <span data-testid={testId && `${testId}-timestamp`}>{formatDate(new Date(updatedAt), "dd.MM.yyyy HH:mm")}</span>
      </div>
    </div>
  )
}

export { LastModificationInfo }
